import {
  Avatar,
  Card,
  CardContent,
  CardMedia,
  createStyles,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  makeStyles,
  Paper,
  Theme,
  Typography,
} from '@material-ui/core'

import React, { useEffect, useState, useContext } from 'react'
import { ICircle, IMember } from 'daily-dose-common'
import { firestore } from '../../firebase-init'
import * as Utilities from '../../utilities'
import circleDefaultImage from '../../assets/images/circle.png'
import { withRouter } from 'react-router'
import { GroupAddIcon } from '../../assets/icons'
import { useDialog } from '../../providers/dialog-provider'
import AddMember from '../../components/add-member'
import { FirestoreContext } from '../../providers/firestore-provider'
import { useHistory } from 'react-router'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
      backgroundColor: theme.palette.background.paper,
    },
    media: {
      height: 250,
    },
  })
)

export interface IMatch {
  params: IMatchParams
  isExact: boolean
  path: string
  url: string
}

interface IMatchParams {
  id: string
}

interface IMyCircleMembersPageProps {
  match: IMatch
  selectedCircle?: ICircle
}

const MyCircleMembersPage = ({
  match,
  selectedCircle,
}: IMyCircleMembersPageProps) => {
  const classes = useStyles()
  const { openDialog, closeDialog } = useDialog()
  const [circle, setCircle] = useState(selectedCircle || ({} as ICircle))
  const circleId = match.params.id
  const circleRef = firestore.collection('circles').doc(circleId)

  // TODO: We might not need snapshots because it could be very expensive to fetch evety time somebody changes something.
  // TODO: Use get() instead of onSnapshot
  useEffect(() => {
    if (selectedCircle) return

    const unsubscribeFromCircle = circleRef.onSnapshot((snapshot) => {
      const circle = Utilities.collectIdAndDocs(snapshot)
      setCircle(circle)
    })

    return () => {
      unsubscribeFromCircle()
    }
    // eslint-disable-next-line
  }, [])

  const onGoToAddAMember = () => {
    openDialog({
      color: 'primary',
      title: 'Add a member',
      confirmText: 'Add',
      custom: true,
      description: (
        <AddMember
          selectedCircle={circle}
          circleId={circleId}
          onAddMember={() => closeDialog()}
          onCancel={() => closeDialog()}
        />
      ),
      onClose: () => true,
      fullScreen: true,
    })
  }

  const { currentUser } = useContext(FirestoreContext)
  const history = useHistory()
  const pictureBelongsToUser = (member: IMember) => currentUser?.id === member.id
  const onGoProfilePage = () => {
    history.push('/profile')
  }

  return (
    <Paper style={{ overflow: 'auto' }}>
      <Card className={classes.root}>
        <CardMedia
          className={classes.media}
          image={circle.photoURL || circleDefaultImage}
          title={circle.name}
        />
        <CardContent>
          <Grid container justify="space-between">
            <Grid item xs={6} container alignItems="center">
              <Typography variant="h5" color="textSecondary" component="h2">
                Members
              </Typography>
            </Grid>
            <Grid item xs={6} container justify="flex-end">
              <IconButton aria-label="add member" onClick={onGoToAddAMember}>
                <GroupAddIcon fontSize="large" />
              </IconButton>
            </Grid>
          </Grid>
          <List className={classes.root}>
            {circle?.members?.map((member: IMember) => {
              return pictureBelongsToUser(member) ? (
                <ListItem
                  key={member.id!}
                  disableGutters
                  divider
                  onClick={onGoProfilePage}
                  button
                >
                  <ListItemAvatar>
                    <Avatar alt={member.displayName} src={member.photoURL} />
                  </ListItemAvatar>
                  <ListItemText primary={member.username} />
                </ListItem>
              ) : (
                <ListItem key={member.id!} disableGutters divider>
                  <ListItemAvatar>
                    <Avatar alt={member.displayName} src={member.photoURL} />
                  </ListItemAvatar>
                  <ListItemText primary={member.username} />
                </ListItem>
              )
            })}
          </List>
        </CardContent>
      </Card>
    </Paper>
  )
}

export default withRouter(MyCircleMembersPage)
